// eslint-disable-next-line import/prefer-default-export
export const BASE_URL = 'https://api.tizeti.com/api/v1';
